import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { Flex, Box } from 'grid-styled';
import styled from '@emotion/styled';
import { ClassNames } from '@emotion/core';

// import AuthDialog from '../Authentication/Auth/AuthDialog';
import { IconButton } from '@material-ui/core';

import { Popover, PopoverAnimationVertical } from 'material-ui/Popover';
import Divider from 'material-ui/Divider';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

import Person from 'material-ui/svg-icons/social/person';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { MuiButton } from '@onehope/design-system-ohw';

import { tablet } from '../../../utils/deviceWidths';
import { resetSegment } from '../../../utils/tracking';
import reassignLocation from '../../../utils/reassignLocation';
import { urlCeHome } from '../../../../server/utils/routeConstants';
import { urlDefaultProfile } from '../../../../server/utils/urlConstants';
import { NavbarDropdown_user } from './__generated__/NavbarDropdown_user.graphql';
import { getImageUrl, getRewardsFlag } from '../../../utils/helpers';

import './NavbarMessage.scss';

export function numberWithCommas(x: number | null | undefined) {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : null;
}

const ProfileImage = styled.div<{ imageUrl: string }>`
  background: url('${({ imageUrl }) => imageUrl}')
    center center / cover no-repeat;
    height: 34px;
    width: 34px;
    vertical-align: middle;
`;

const TextContainer = styled.div`
  display: flex;
  padding: 0 5px 0 11px;
  flex-direction: column;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  color: #393939;
`;

const PointBalance = styled.div`
  color: #88898a;
`;

const SignInButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const SignInButtonStyles = {
  marginBottom: 0,
  marginRight: 10,
  width: 120,
};

interface NavbarDropdownProps {
  user: NavbarDropdown_user;
  containerWidth: number;
  handleLogout: (fn: () => void) => void;
  // eslint-disable-next-line
  location: string;
  handleRouteChange: (
    url: string,
    something?: any,
    somethingelse?: boolean,
  ) => {};
}

interface NavbarDropdownState {
  // eslint-disable-next-line
  open: boolean;
  anchorEl: HTMLElement | any;
}

class NavbarDropdown extends React.Component<
  NavbarDropdownProps,
  NavbarDropdownState
> {
  constructor(props: NavbarDropdownProps) {
    super(props);

    this.state = {
      open: false,
      anchorEl: null,
    };
  }

  handleTouchTap = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
    // This prevents ghost click.
  };

  handleRequestClose = () => {
    this.setState(() => ({
      open: false,
    }));
  };

  handleAccountsRouteChange = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    handleRouteChange('/account', null, true);
  };

  handleAccountOrdersRouteChange = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    handleRouteChange('/account/orders', null, true);
  };

  handleAccountAddressesRouteChange = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    handleRouteChange('/account/addresses', null, true);
  };

  handleLogin = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    const redirectUrl = encodeURI(window.location.href);
    if (!window.location.pathname.includes('login')) {
      handleRouteChange(`/login?redirect_uri=${redirectUrl}`);
    }
  };

  handleAccountPaymentsRouteChange = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    handleRouteChange('/account/payments', null, true);
  };

  handleAccountRewardsRouteChange = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    handleRouteChange('/account/rewards', null, true);
  };

  handleAccountGrapefulRouteChange = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    handleRouteChange('/account/subscriptions', null, true);
  };

  handleAccountCeDashRouteChange = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    reassignLocation(urlCeHome, handleRouteChange);
  };

  handleAdminRouteChange = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.handleRequestClose();
    const { handleRouteChange } = this.props;
    handleRouteChange('/admin', null, true);
  };

  handleBackofficeClick = () => {
    if (window) {
      // Link sends user directly to backoffice url
      // window.open(`https://backoffice.onehopewine.com`);
      // Open in new window. The component will then auto-redirect to backoffice and sso if possible.
      window.open('/trinity-login');
    }
    return true;
  };

  handleWorkrampClick = () => {
    if (window) {
      // Link sends user directly into SSO clientId
      // window.open(
      //   `${
      //     process.env.SERVER_DNS
      //   }/sso?clientId=a6b12e98-f646-491f-9590-223c1bdf7bf2&redirect_uri=https%3A%2F%2Fapp.workramp.com%2Fauth%2Fonehope%2Fcallback&state=OHW`,
      // );
      // link sends user to workramp email input page
      window.open('https://onehopewine.app.workramp.com/login');
    }
    return true;
  };

  handleResourcesClick = () => {
    if (window) {
      // Link sends user directly into outside link
      window.open(`http://knowledge.onehopewine.com/resource-center-overview`);
    }
    return true;
  };

  handleCrushClick = () => {
    if (window) {
      // Link sends user directly into outside link
      window.open(`https://crush.onehopewine.com/`);
    }
    return true;
  };

  userLogout = () => {
    const { handleLogout, handleRouteChange, location } = this.props;
    this.handleRequestClose();
    const onCompleted = () => {
      if (location.includes('checkout')) {
        handleRouteChange('/');
      }
      resetSegment();
    };
    return handleLogout(onCompleted);
  };

  getProfileImage = () => {
    const { profile } = this.props.user;
    return profile && profile.image
      ? getImageUrl(profile.image, 'thumb')
      : `${urlDefaultProfile}default_profile.svg`;
  };

  render() {
    const { containerWidth, user, flags } = this.props;

    const { open } = this.state;

    let role;
    let firstName;
    let permissions;
    let conciergeUser;
    let pointBalance = 0;
    if (!user) {
      return null;
    }
    if (user) {
      ({ firstName, role, conciergeUser, permissions, pointBalance } = user);
    }

    const isConciergeMode =
      conciergeUser ||
      (permissions &&
        permissions.oneCommerce &&
        permissions.oneCommerce.ceo &&
        permissions.oneCommerce.ceo.access);
    const isAdminMode =
      permissions &&
      permissions.oneCommerce &&
      permissions.oneCommerce.superAdmin &&
      permissions.oneCommerce.superAdmin.access;
    const isAnonymous = role === 'anonymous';
    const adminText = 'Admin Dashboard';
    const ceoAdminText = 'CE Back Office';
    // const ceBackOfficeText = 'CE Backoffice';
    // const trainingCenterText = 'Training Center';
    // const resourcesText = 'Resources';
    // const crushText = 'Register for CRUSH 2019';
    const signIn = 'Sign In';
    const myProfileText = 'Profile';
    const myOrdersText = 'Orders';
    const myAddressesText = 'Addresses';
    const myPaymentsText = 'Payments';
    const myRewardsText = 'Rewards';
    const myGrapefulText = 'Subscriptions';
    const signOutText = 'Sign Out';
    const rewardPoints = getRewardsFlag(flags);

    // use paddingTop/paddingBottom instead of padding,
    // because padding didn't seem to register the style
    const menuListItemStyle = {
      paddingTop: 8,
      paddingBottom: 8,
    };

    const menuItems = [
      <MenuItem
        key={myProfileText}
        primaryText={myProfileText}
        onClick={this.handleAccountsRouteChange}
        data-cypress={`${myProfileText}-menu-item`}
      />,
      <MenuItem
        key={myOrdersText}
        primaryText={myOrdersText}
        onClick={this.handleAccountOrdersRouteChange}
        data-cypress={`${myOrdersText}-menu-item`}
      />,
      <MenuItem
        key={myAddressesText}
        primaryText={myAddressesText}
        onClick={this.handleAccountAddressesRouteChange}
        data-cypress={`${myAddressesText}-menu-item`}
      />,
      <MenuItem
        key={myPaymentsText}
        primaryText={myPaymentsText}
        onClick={this.handleAccountPaymentsRouteChange}
        data-cypress={`${myPaymentsText}-menu-item`}
      />,
      <MenuItem
        key={myRewardsText}
        primaryText={myRewardsText}
        style={{ display: rewardPoints ? 'inherit' : 'none' }}
        onClick={this.handleAccountRewardsRouteChange}
        data-cypress={`${myRewardsText}-menu-item`}
      />,
      <MenuItem
        key={myGrapefulText}
        //data-cypress="myGrapefulClub"
        primaryText={myGrapefulText}
        onClick={this.handleAccountGrapefulRouteChange}
        data-cypress={`${myGrapefulText}-menu-item`}
      />,
      <Divider key="navigationDivider" />,
      <MenuItem
        key={signOutText}
        className="signOutButton"
        rightIcon={
          <Person style={{ width: 24, height: 24, paddingRight: 10 }} />
        }
        primaryText={signOutText}
        data-cypress={`${signOutText}-menu-item`}
        onClick={this.userLogout}
      />,
    ];

    if (isAdminMode) {
      menuItems.unshift(
        <MenuItem
          key={adminText}
          primaryText={adminText}
          onClick={this.handleAdminRouteChange}
          data-cypress={`${adminText}-menu-item`}
        />,
        <Divider key="ceoDivider2" />,
      );
    }
    if (isConciergeMode) {
      menuItems.unshift(
        <MenuItem
          key={ceoAdminText}
          primaryText={ceoAdminText}
          onClick={this.handleAccountCeDashRouteChange}
          data-cypress={`${ceoAdminText}-menu-item`}
        />,
        // <MenuItem
        //   key={ceBackOfficeText}
        //   primaryText={ceBackOfficeText}
        //   onClick={this.handleBackofficeClick}
        //   data-cypress={`${ceBackOfficeText}-menu-item`}
        // />,
        // <MenuItem
        //   key={trainingCenterText}
        //   primaryText={trainingCenterText}
        //   onClick={this.handleWorkrampClick}
        //   data-cypress={`${trainingCenterText}-menu-item`}
        // />,
        // <MenuItem
        //   key={resourcesText}
        //   primaryText={resourcesText}
        //   onClick={this.handleResourcesClick}
        //   data-cypress={`${resourcesText}-menu-item`}
        // />,
        // <MenuItem
        //   key={crushText}
        //   primaryText={crushText}
        //   onClick={this.handleCrushClick}
        //   data-cypress={`${crushText}-menu-item`}
        // />,
        <Divider key="ceoDivider" />,
      );
    }
    const profileImage = this.getProfileImage();
    return (
      <Flex>
        {isAnonymous ? (
          <SignInButton>
            <MuiButton
              type="PRIMARY"
              style={SignInButtonStyles}
              onClick={this.handleLogin}
              data-cypress="login-button"
            >
              Sign In
            </MuiButton>
          </SignInButton>
        ) : (
          <Box>
            <ClassNames>
              {({ css, cx }) => (
                <IconButton
                  className={css`
                    && {
                      &&:hover {
                        background-color: transparent !important;
                      }
                    }
                  `}
                  disableRipple
                  onClick={this.handleTouchTap}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="NavBarMessageImageContainer">
                      <div className="media-photo media-round">
                        <ProfileImage imageUrl={profileImage} />
                      </div>
                    </div>
                    {rewardPoints && (
                      <TextContainer>
                        {firstName && <div>Hi, {firstName}</div>}
                        <PointBalance>
                          {numberWithCommas(pointBalance) || 0} points
                        </PointBalance>
                      </TextContainer>
                    )}
                    <ArrowDropDown
                      className={css`
                        margin: auto 0;
                      `}
                    />
                  </div>
                </IconButton>
              )}
            </ClassNames>
            <Popover
              open={open}
              anchorEl={this.state.anchorEl}
              animation={PopoverAnimationVertical}
              anchorOrigin={{
                horizontal: 'right',
                vertical: 'bottom',
              }}
              targetOrigin={{
                horizontal: 'right',
                vertical: 'top',
              }}
              onRequestClose={this.handleRequestClose}
            >
              <Menu
                listStyle={menuListItemStyle}
                desktop={containerWidth > tablet}
              >
                {menuItems}
              </Menu>
            </Popover>
          </Box>
        )}
      </Flex>
    );
  }
}

export default createFragmentContainer(NavbarDropdown, {
  user: graphql`
    fragment NavbarDropdown_user on User {
      firstName
      role
      conciergeUser {
        id
      }
      profile {
        id
        image
      }
      permissions {
        id
        id
        oneCommerce {
          id
          superAdmin {
            access
          }
          ceo {
            access
          }
        }
      }
      pointBalance
    }
  `,
});
